import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function AddCustomRequest(fromData) {
  const jsonData = Object.fromEntries(fromData.entries());

  const res = await api.post(routes.SUPPLIER_CUSTOM_REQUEST, jsonData);
  return res;
}
